import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_line_down",
  "use": "icon-icon_line_down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icon_line_down\"><path d=\"M748.8 321.92l72.384 72.32-316.8 316.8h-0.128l-316.8-316.8 72.448-72.32 244.48 244.352L748.8 321.92z\" p-id=\"2958\" fill=\"#4877F4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol